module.exports = __webpack_public_path__ + "img/qgbqs_b_32-50.prt.6a3ec20e.jpg";